import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionLabel } from "../Reveal";

const PATHS = [
  {
    to: "/sports",
    label: "Sports",
    sub: "Spartan · HYROX · Race Journey",
    img: "https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/04ybcmao_IMG_2832.webp",
    focus: "46% 42%",
    zoom: 1.3,
    color: "#BAF173",
  },
  {
    to: "/music",
    label: "Music",
    sub: "Beats · Production · DJ",
    img: "https://customer-assets-lqy194kg.emergentagent.net/job_racer-beats-pro/artifacts/a93idfoh_IMG_9092.jpg",
    focus: "center 30%",
    color: "#6735FA",
  },
];

export const PathChooser = () => (
  <section id="explore" className="relative py-24 sm:py-32 bg-black border-t border-white/10" data-testid="path-chooser">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
      <SectionLabel color="#BAF173">Choose your path</SectionLabel>
      <Reveal>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold uppercase tracking-tight text-white leading-[0.95] mb-4">
          Two Worlds.<br />One Discipline.
        </h2>
      </Reveal>
      <Reveal delay={0.08}>
        <p className="text-white/50 text-base max-w-xl mb-12">
          The same drive fuels both arenas. Pick where you want to go.
        </p>
      </Reveal>

      <div className="grid md:grid-cols-2 gap-5">
        {PATHS.map((p, i) => (
          <Reveal key={p.to} delay={i * 0.1}>
            <Link
              to={p.to}
              data-testid={`path-${p.label.toLowerCase()}`}
              className="group relative block h-[380px] md:h-[480px] overflow-hidden border border-white/10 shadow-[0_10px_40px_rgba(0,0,0,0.5)] transition-all duration-500 hover:-translate-y-1"
            >
              <div className="absolute inset-0 transition-transform duration-[900ms] group-hover:scale-110">
                <img
                  src={p.img}
                  alt={p.label}
                  style={{ objectPosition: p.focus, transform: p.zoom ? `scale(${p.zoom})` : undefined }}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/45 to-black/10 group-hover:via-black/60 transition-colors duration-500" />
              <div
                className="absolute inset-x-0 bottom-0 h-1 origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500"
                style={{ background: p.color }}
              />
              <div className="absolute inset-0 p-8 md:p-10 flex flex-col justify-end">
                <span className="font-display text-xs uppercase tracking-[0.3em] mb-2" style={{ color: p.color }}>{p.sub}</span>
                <div className="flex items-center justify-between">
                  <h3 className="font-display text-5xl md:text-7xl font-bold uppercase tracking-tight text-white leading-none">{p.label}</h3>
                  <ArrowUpRight size={44} className="shrink-0 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" style={{ color: p.color }} />
                </div>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
